module.exports = __webpack_public_path__ + "static/media/clickatell_logo.2782d039.svg";